import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { PurchasePayload, PurchaseResource } from "../types";

const createPurchase = async (payload: PurchasePayload) => {
  const { purchase } = (await stellar.action("createPurchase", payload)) as {
    purchase: PurchaseResource;
  };

  return purchase;
};

export const useCreatePurchaseMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPurchase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["purchases"] });
    },
  });
};
